import { render, staticRenderFns } from "./proReviewDecisionMaking.vue?vue&type=template&id=87b7f0ec&scoped=true&"
import script from "./proReviewDecisionMaking.vue?vue&type=script&lang=js&"
export * from "./proReviewDecisionMaking.vue?vue&type=script&lang=js&"
import style0 from "./proReviewDecisionMaking.vue?vue&type=style&index=0&id=87b7f0ec&scoped=true&lang=css&"
import style1 from "./proReviewDecisionMaking.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b7f0ec",
  null
  
)

export default component.exports